import { Controller } from "stimulus";
import { M } from "@materializecss/materialize/dist/js/materialize";
import dispatchCustomEvent from "../../functions/dispatchCustomEvent.js";

export default class extends Controller {
  static get targets() {
    return ["select"];
  }

  static get values() {
    return { default: String };
  }

  connect() {
    this._initializeCustomSelect();

    this.handleElementEnable = this._initializeCustomSelect.bind(this);
    this.selectTarget.addEventListener("element:enable", this.handleElementEnable);

    dispatchCustomEvent(document, `${this.element.id}-loaded`);
  }

  disconnect() {
    this.instance?.destroy();
  }

  resetSelection() {
    const defaultValueOption = this.instance._values.find((v) => v.el.value === this.defaultValue);

    if (defaultValueOption) {
      this.instance._selectValue(defaultValueOption);
      this.highlightIfHasSelected();
      this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  highlightIfHasSelected() {
    if (this.selectedValue === this.defaultValue) {
      this.input.classList.add(this.labelGrayColorCssClass);
    } else {
      this.input.classList.remove(this.labelGrayColorCssClass);
    }
  }

  _initializeCustomSelect() {
    const label = this.element.querySelector("label");

    this.instance?.destroy();
    M.FormSelect.init(this.selectTarget);
    this._restoreLabel(label);
    this.highlightIfHasSelected();
  }

  // Re-initialising on element:enable (selects--show-when-value enabling a frequency's selects) destroys the
  // Materialize wrapper, which takes the label it moved inside with it, so the label is put back after the select.
  _restoreLabel(label) {
    if (!label || label.isConnected) return;

    this.input.after(label);
  }

  get input() {
    return this.element.querySelector("input");
  }

  get selectedOption() {
    return this.element.querySelector("select");
  }

  get selectedValue() {
    return this.element.querySelector("select").value;
  }

  get defaultValueOption() {
    return this.element.querySelector(`option[value="${this.defaultValue}"]`);
  }

  set selectedValue(value) {
    this.element.querySelector("select").value = value;
  }

  get labelGrayColorCssClass() {
    return "label-gray-color";
  }

  get instance() {
    return M.FormSelect.getInstance(this.selectTarget);
  }
}
